import { Button, ButtonsGroup, Heading, PageHeader, PageWrapper } from "#/atoms";
import { CustomTable, ResponsiveCell } from "#/molecules";
import { FC, memo } from "react";

import { Column } from "react-table";
import { NATURAL } from "@/theme";
import { WorkerOrderOffersProps } from "./WorkerOrderOffers.interface";
import { formatShortDateString } from "@/helpers";

const WorkerOrderOffers: FC<WorkerOrderOffersProps> = ({ isAdmin, loading, workerOrderOffers }) => {

  const getColumns = () => { 
    const cols : Column[] = [
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Job Number" value={value} ></ResponsiveCell>;
      },
      Header: 'Job Number',
      accessor: 'orderId',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Address" value={value} ></ResponsiveCell>;
      },
      Header: 'Address',
      accessor: 'address',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Appointment Date" value={formatShortDateString(value)} ></ResponsiveCell>;
      },
      Header: 'Appointment Date',
      accessor: 'appointmentDate',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Services" value={value} ></ResponsiveCell>;
      },
      Header: 'Services',
      accessor: 'services',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Comission" value={value} ></ResponsiveCell>;
      },
      Header: 'Comission',
      accessor: 'amount',
    }
  ]

  if (isAdmin){
    cols.push({
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Status" value={value} ></ResponsiveCell>;
      },
      Header: 'Status',
      accessor: 'status',
    });
  }
  else 
  {
    cols.push({
      Cell: ({ value }) => {
          return (
            <ButtonsGroup fullWidth>
              <Button
              actionType='solid'
              onClick={() => console.log(value)}
              buttonSize="sm"
              >
                Accept
              </Button>
              <Button
              actionType='solid'
              onClick={() => console.log(value)}
              buttonSize="sm"
              >
                Decline
              </Button>
            </ButtonsGroup>
          );
        },
      Header: '',
      accessor: 'id',
      id: 'button'
    })
  }


    return cols as Column[];

  };

  return (
    <PageWrapper>
      <PageHeader>
        <Heading scale="h1" fontColor={NATURAL.K}>Order Offers</Heading>
      </PageHeader>
      <CustomTable columns={getColumns()} data={workerOrderOffers} loading={loading} pagination={{ pageIndex: 0, pageSize: 10 }} />
    </PageWrapper>
  );
};

export default memo(WorkerOrderOffers);